import { ETRIS03_TransactionMonitoring } from "./ETRIS03_TransactionMonitoring";

export const TransactonMonitoringReport = {
    "sections": [ETRIS03_TransactionMonitoring]
}